import { Skeleton } from '@mui/material'

import { Organism } from '@/core/architecture'

export type CollectionBoxSkeletonProps = {
  fullWidth?: boolean
}

export const CollectionBoxSkeleton: Organism<CollectionBoxSkeletonProps> = ({
  fullWidth,
}) => (
  <Skeleton
    variant="rectangular"
    width={fullWidth ? '100%' : 315}
    height={190}
  />
)
